const template = state => state.template;
const variants = state => state.template.variants;
const notFound = state => state.notFound;
const furtherOffers = state => state.furtherOffers;
const staticStorage = state => state.staticStorage;
export default {
  template,
  variants,
  notFound,
  furtherOffers,
  staticStorage
};